import { Component, inject } from '@angular/core';
import { QrCodeService } from '@artemis-software/wr-api';
import { createForm } from '@sonofabit/ng-core';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { ContractorCredentialsService } from '@services/contractor-credentials.service';
import { QrSessionService } from '@services/qr-session.service';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

@Component({
  standalone: false,
  selector: 'wr-qr-code-pin-login',
  templateUrl: './qr-code-pin-login.component.html',
  styleUrls: ['./qr-code-pin-login.component.scss'],
})
export class QrCodePinLoginComponent {

  readonly route = inject(ActivatedRoute);
  readonly toastr = inject(NbToastrService);
  readonly router = inject(Router);
  readonly qrCodeService = inject(QrCodeService);
  readonly contractorCredentialsService = inject(ContractorCredentialsService);
  readonly qrSessionService = inject(QrSessionService);

  readonly shortCode = toSignal(
    this.route.paramMap.pipe(map((params) => params.get('shortCode'))),
    { initialValue: null }
  );

  form = createForm(({ field }) => ({
    pin: field({
      value: '',
      validators: [Validators.required],
    }),
  }));

  onSubmit() {
    const pin = this.form.get('pin')?.value;
    const shortCode = this.shortCode();

    if (!pin || !shortCode) return;

    this.qrCodeService.verifyAccess(
      shortCode, pin
    ).subscribe({
      next: async (isValid) => {
        if (isValid) {
          this.contractorCredentialsService.setContractorCredentials(shortCode, pin);

          this.toastr.success('PIN erfolgreich verifiziert', 'Zugriff erlaubt');
          const external = await this.qrSessionService.isExternalUser();
          this.router.navigate(external ? ['/building-qr', shortCode] : ['/building-qr', shortCode, 'tga']);
        } else {
          this.toastr.danger('PIN ungültig', 'Zugriff verweigert');
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === HttpStatusCode.TooManyRequests) {
          this.toastr.danger('Zu viele fehlgeschlagene Versuche. Bitte später erneut versuchen.', 'Gesperrt');
          return;
        }
        this.toastr.danger('Fehler bei der PIN-Überprüfung', 'Fehler');
      },
    });
  }
}
